export default "__VITE_ASSET__32U_sDX2__"